export default "__VITE_ASSET__Bas0M3oq__"